import { Button, Container } from "react-bootstrap";
import { ChevronLeftIcon } from "@heroicons/react/outline";
import PropTypes from "prop-types";

import "./PageHeader.scss";
import { useAuth } from "../services/wp.auth.service";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const PageHeader = ({
	children,
	className,
	fluid,
	id,
	showBack,
	style,
	title,
	titleClassName
}) => {
	const { user } = useAuth();
	const navigate = useNavigate();
	const goBack = useCallback(() => navigate(-1), [navigate]); /* eslint-disable-line no-magic-numbers */

	return (
		<Container
			as="header"
			className={`bg-white d-flex page-header align-items-center ${className}`}
			fluid={fluid}
			id={id}
			style={style}
		>
			{ showBack ? (
				<Button className="me-4" onClick={goBack} size="sm" variant="outlined-light">
					<ChevronLeftIcon />

					{"Back"}
				</Button>) : null}

			<h1 className={titleClassName}>
				{user ? `Welcome ${user.firstName || user.name}` : title}
			</h1>

			{children}
		</Container>
	);
};

PageHeader.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	fluid: PropTypes.bool,
	id: PropTypes.string,
	showBack: PropTypes.bool,
	style: PropTypes.shape({}),
	title: PropTypes.string.isRequired,
	titleClassName: PropTypes.string
};

PageHeader.defaultProps = {
	children: "",
	className: "",
	fluid: false,
	id: "page-header",
	showBack: false,
	style: {},
	titleClassName: "me-auto py-4"
};

export default PageHeader;
